import React from 'react';
var FilePickerSource = function FilePickerSource(_ref) {
  var active = _ref.active,
    children = _ref.children;
  return !active ? null : /*#__PURE__*/React.createElement(React.Fragment, null, children);
};
export default FilePickerSource;